import { Injectable, ɵɵdefineInjectable, ɵɵinject, Component, ViewChild, HostListener, NgModule } from '@angular/core';
import { Http } from '@angular/http';
import { isString, isNumber } from 'util';
import { connect } from 'socket.io-client';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/json.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class JsonService {
    /**
     * @param {?} _http
     */
    constructor(_http) {
        this._http = _http;
    }
    /**
     * @param {?} prjName
     * @param {?} jsonFileName
     * @return {?}
     */
    getCanvasData(prjName, jsonFileName) {
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            this.getData(prjName, jsonFileName).then((/**
             * @param {?} res
             * @return {?}
             */
            res => {
                resolve(res);
            }));
        }));
    }
    /**
     * @param {?} prjName
     * @param {?} jsonFileName
     * @return {?}
     */
    getAssetsData(prjName, jsonFileName) {
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            this.getData(prjName, jsonFileName).then((/**
             * @param {?} res
             * @return {?}
             */
            res => {
                resolve(res);
            }));
        }));
    }
    /**
     * @param {?} prjName
     * @param {?} jsonFileName
     * @return {?}
     */
    getObjectData(prjName, jsonFileName) {
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            this.getData(prjName, jsonFileName).then((/**
             * @param {?} res
             * @return {?}
             */
            res => {
                resolve(res);
            }));
        }));
    }
    /**
     * @param {?} prjName
     * @param {?} jsonFileName
     * @return {?}
     */
    getObjectProperties(prjName, jsonFileName) {
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            this.getData(prjName, jsonFileName).then((/**
             * @param {?} res
             * @return {?}
             */
            res => {
                resolve(res);
            }));
        }));
    }
    /**
     * @param {?} prjName
     * @param {?} jsonFileName
     * @return {?}
     */
    getAnimationData(prjName, jsonFileName) {
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            this.getData(prjName, jsonFileName).then((/**
             * @param {?} res
             * @return {?}
             */
            res => {
                resolve(res);
            }));
        }));
    }
    /**
     * @param {?} prjName
     * @param {?} jsonFileName
     * @return {?}
     */
    getData(prjName, jsonFileName) {
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            /** @type {?} */
            const url = prjName + '/data/' + jsonFileName + '.json';
            return this._http.get(url).subscribe((/**
             * @param {?} data
             * @return {?}
             */
            data => {
                resolve(data.json());
            }), (/**
             * @param {?} err
             * @return {?}
             */
            (err) => {
                console.log('error:get-config:', err);
                reject(null);
            }));
        }));
    }
}
JsonService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
JsonService.ctorParameters = () => [
    { type: Http }
];
/** @nocollapse */ JsonService.ngInjectableDef = ɵɵdefineInjectable({ factory: function JsonService_Factory() { return new JsonService(ɵɵinject(Http)); }, token: JsonService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    JsonService.prototype._http;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/xldata.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const objects = {};
class XldataService {
    /**
     * @param {?} _http
     */
    constructor(_http) {
        this._http = _http;
    }
    /**
     * @param {?} apipath
     * @param {?} jsonFileName
     * @param {?} proj
     * @return {?}
     */
    getCanvasData(apipath, jsonFileName, proj) {
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            this.getData(apipath, jsonFileName, proj).then((/**
             * @param {?} res
             * @return {?}
             */
            res => {
                resolve(res);
            }));
        }));
    }
    /**
     * @param {?} apipath
     * @param {?} jsonFileName
     * @param {?} proj
     * @return {?}
     */
    getAssetsData(apipath, jsonFileName, proj) {
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            this.getData(apipath, jsonFileName, proj).then((/**
             * @param {?} res
             * @return {?}
             */
            res => {
                resolve(res);
            }));
        }));
    }
    /**
     * @param {?} apipath
     * @param {?} jsonFileName
     * @param {?} proj
     * @return {?}
     */
    getObjectData(apipath, jsonFileName, proj) {
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            this.getData(apipath, jsonFileName, proj).then((/**
             * @param {?} res
             * @return {?}
             */
            res => {
                resolve(res);
            }));
        }));
    }
    /**
     * @param {?} apipath
     * @param {?} jsonFileName
     * @param {?} proj
     * @return {?}
     */
    getObjectProperties(apipath, jsonFileName, proj) {
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            this.getData(apipath, jsonFileName, proj).then((/**
             * @param {?} res
             * @return {?}
             */
            res => {
                resolve(res);
            }));
        }));
    }
    /**
     * @param {?} apipath
     * @param {?} jsonFileName
     * @param {?} proj
     * @return {?}
     */
    getAnimationData(apipath, jsonFileName, proj) {
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            this.getData(apipath, jsonFileName, proj).then((/**
             * @param {?} res
             * @return {?}
             */
            res => {
                resolve(res);
            }));
        }));
    }
    /**
     * @param {?} api
     * @param {?} xlFileName
     * @param {?} proj
     * @return {?}
     */
    getData(api, xlFileName, proj) {
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            return this._http.post(api + xlFileName, { 'filename': proj })
                .subscribe((/**
             * @param {?} data
             * @return {?}
             */
            data => {
                resolve(this.modifyStructure(data.json()));
            }), (/**
             * @param {?} err
             * @return {?}
             */
            (err) => {
                reject(null);
            }));
        }));
    }
    /**
     * @param {?} data
     * @return {?}
     */
    modifyStructure(data) {
        /** @type {?} */
        let modelDefn = data;
        console.log("modelDefn :", modelDefn);
        Object.entries(modelDefn).forEach((/**
         * @param {?} __0
         * @return {?}
         */
        ([key, value]) => {
            objects[key] = {
                "type": value['type'],
                "parent": value['parent'],
                "name": value['name'],
                "model": value['model'],
                "place": {
                    "pos": { x: value['pos_x'], y: value['pos_y'], z: value['pos_z'] },
                    "rot": { x: value['rot_x'], y: value['rot_y'], z: value['rot_z'] },
                    "size": value['size']
                },
                "label": value['label']
            };
        }));
        return { "objects": objects };
    }
}
XldataService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
XldataService.ctorParameters = () => [
    { type: Http }
];
/** @nocollapse */ XldataService.ngInjectableDef = ɵɵdefineInjectable({ factory: function XldataService_Factory() { return new XldataService(ɵɵinject(Http)); }, token: XldataService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    XldataService.prototype._http;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/socketdata.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SocketdataService {
    /**
     * @param {?} _http
     */
    constructor(_http) {
        this._http = _http;
    }
    /**
     * @param {?} prjName
     * @param {?} jsonFileName
     * @return {?}
     */
    getCanvasData(prjName, jsonFileName) {
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            this.updateStatus(prjName, jsonFileName).then((/**
             * @param {?} res
             * @return {?}
             */
            res => {
                resolve(res);
            }));
        }));
    }
    /**
     * @param {?} apipath
     * @param {?} jsonFileName
     * @return {?}
     */
    getAssetsData(apipath, jsonFileName) {
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            this.updateStatus(apipath, jsonFileName).then((/**
             * @param {?} res
             * @return {?}
             */
            res => {
                resolve(res);
            }));
        }));
    }
    /**
     * @param {?} apipath
     * @param {?} jsonFileName
     * @return {?}
     */
    getObjectData(apipath, jsonFileName) {
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            this.updateStatus(apipath, jsonFileName).then((/**
             * @param {?} res
             * @return {?}
             */
            res => {
                resolve(res);
            }));
        }));
    }
    /**
     * @param {?} apipath
     * @param {?} jsonFileName
     * @return {?}
     */
    getObjectProperties(apipath, jsonFileName) {
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            this.updateStatus(apipath, jsonFileName).then((/**
             * @param {?} res
             * @return {?}
             */
            res => {
                resolve(res);
            }));
        }));
    }
    /**
     * @param {?} apipath
     * @param {?} jsonFileName
     * @return {?}
     */
    getAnimationData(apipath, jsonFileName) {
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            this.updateStatus(apipath, jsonFileName).then((/**
             * @param {?} res
             * @return {?}
             */
            res => {
                resolve(res);
            }));
        }));
    }
    /**
     * @param {?} api
     * @param {?} data
     * @return {?}
     */
    updateStatus(api, data) {
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            return this._http.post(api, data).subscribe((/**
             * @param {?} data
             * @return {?}
             */
            data => {
                resolve(data.json());
            }), (/**
             * @param {?} err
             * @return {?}
             */
            (err) => {
                console.log('error:get-config:', err);
                reject(null);
            }));
        }));
    }
}
SocketdataService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
SocketdataService.ctorParameters = () => [
    { type: Http }
];
/** @nocollapse */ SocketdataService.ngInjectableDef = ɵɵdefineInjectable({ factory: function SocketdataService_Factory() { return new SocketdataService(ɵɵinject(Http)); }, token: SocketdataService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    SocketdataService.prototype._http;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/dataservice.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DataService {
    /**
     * @param {?} _JsonService
     * @param {?} _XldataService
     * @param {?} _SocketdataService
     */
    constructor(_JsonService, _XldataService, _SocketdataService) {
        this._JsonService = _JsonService;
        this._XldataService = _XldataService;
        this._SocketdataService = _SocketdataService;
        this.setting = {
            baseUrl: "",
            xlapipath: "",
            actions: {
                keyDown: {}
            },
            camera: {},
            lights: {},
            materials: {
                all: ""
            },
            shapes: {},
            venue: ""
        };
        this.keyDown = {
            h: [],
            a: [],
            s: [],
            x: [],
            z: [],
            t: []
        };
        this.camera = {
            type: "",
            yaw: 1000,
            pitch: 1000,
            minDistance: 1000,
            maxDistance: 1000,
            distance: 1000,
            target: { x: 1000, y: 1000, z: 1000 },
            fov: 1000,
            inertia: 1000,
            groundLevel: 1000,
            tumbleSensitivity: 1000,
            trackSensitivity: 1000,
            wheelPrecision: 1000,
            views: {}
        };
        this.light = {
            type: "",
            direction: { x: 1000, y: 1000, z: 1000 },
            diffuseColor: { r: 1000, g: 1000, b: 1000 },
            specularColor: { r: 1000, g: 1000, b: 1000 },
            castShadow: false
        };
        this.object = {};
        this.JsonPath = '../assets/dfx-static';
    }
    /**
     * @param {?} data
     * @return {?}
     */
    setPaths(data) {
        console.log('setpaths: ', data);
        this.JsonPath = data.JsonPath;
        this.xlPath = data.xlPath;
        this.socketPath = data.socketPath;
        this.socketport = data.socketport;
        this.key = "socketdata";
        this.project = data.project;
    }
    /**
     * @param {?} srcType
     * @return {?}
     */
    getPaths(srcType) {
        /** @type {?} */
        let apiPath = this.JsonPath;
        if (srcType == 'json') {
            apiPath = this.JsonPath;
        }
        else if (srcType == 'xl') {
            apiPath = this.xlPath;
        }
        else if (srcType == 'socket') {
            apiPath = this.socketPath;
        }
        return apiPath;
    }
    /**
     * @param {?} data
     * @return {?}
     */
    validateCanvasData(data) {
        this.setPaths(data);
        for (let m in this.setting) {
            if (!data[m]) {
                console.log(m + ' is undefined');
            }
            else {
                if (m == 'actions') {
                    for (let k in this.keyDown) {
                        if (!data.actions.keyDown[k]) {
                            console.log(k + ' key is undefined');
                        }
                        else if (!data.actions.keyDown[k][0].view) {
                            console.log(k + ' key value is not define');
                        }
                        else if (!isString(data.actions.keyDown[k][0].view)) {
                            console.log(k + ' key value is not a string');
                        }
                    }
                }
                else if (m == 'camera') {
                    for (let c in this.camera) {
                        if (!data.camera[c]) {
                            console.log("camera's " + c + ' property is undefined');
                        }
                        else if (c == 'type' && !isString(data.camera[c])) {
                            console.log("camera's " + c + " value is not a string");
                        }
                        else if (c == 'views') {
                            for (let k in this.keyDown) {
                                if (!data.camera[c][k]) {
                                    console.log("camera's " + k + ' key is undefined');
                                }
                            }
                        }
                        else if (c == 'target') {
                            for (let t in data.camera[c]) {
                                if (!data.camera[c][t]) {
                                    console.log("camera's " + c + ' ' + t + ' value is undefined');
                                }
                            }
                        }
                        else {
                            if (!isNumber(c !== 'type' && data.camera[c])) {
                                console.log("camera's " + c + " value is not a number");
                            }
                        }
                    }
                }
                else if (m == 'lights') {
                    for (let l in data.lights) {
                        for (let t in this.light) {
                            // data.lights[l][t]
                        }
                    }
                }
            }
        }
        return true;
    }
    /**
     * @param {?} data
     * @return {?}
     */
    validateAssetsData(data) {
        // for (let m in this.object) {
        //   if (!data[m]) {
        //     console.log(m + ' is undefined');
        //   } else {
        //     if (m == 'actions') {
        //       for (let k in this.keyDown) {
        //         if (!data.actions.keyDown[k]) {
        //           console.log(k + ' key is undefined');
        //         } else if (!data.actions.keyDown[k][0].view) {
        //           console.log(k + ' key value is not define');
        //         } else if (!isString(data.actions.keyDown[k][0].view)) {
        //           console.log(k + ' key value is not a string');
        //         }
        //       }
        //     } else if (m == 'camera') {
        //       for (let c in this.camera) {
        //         if (!data.camera[c]) {
        //           console.log("camera's " + c + ' property is undefined');
        //         } else if (c == 'type' && !isString(data.camera[c])) {
        //           console.log("camera's " + c + " value is not a string");
        //         } else if (c == 'views') {
        //           for (let k in this.keyDown) {
        //             if (!data.camera[c][k]) {
        //               console.log("camera's " + k + ' key is undefined');
        //             }
        //           }
        //         } else if (c == 'target') {
        //           for (let t in data.camera[c]) {
        //             if (!data.camera[c][t]) {
        //               console.log("camera's " + c + ' ' + t + ' value is undefined');
        //             }
        //           }
        //         } else {
        //           if (!isNumber(c !== 'type' && data.camera[c])) {
        //             console.log("camera's " + c + " value is not a number");
        //           }
        //         }
        //       }
        //     } else if (m == 'lights') {
        //       for (let l in data.lights) {
        //         for (let t in this.light) {
        //           // data.lights[l][t]
        //         }
        //       }
        //     }
        //   }
        // }
        return true;
    }
    /**
     * @param {?} data
     * @return {?}
     */
    validateObjectData(data) {
        return true;
    }
    /**
     * @param {?} data
     * @return {?}
     */
    validateObjectProperties(data) {
        return true;
    }
    /**
     * @param {?} data
     * @return {?}
     */
    validateAnimationData(data) {
        return true;
    }
    /**
     * @param {?} data
     * @return {?}
     */
    validateData(data) {
        return true;
    }
    /**
     * @param {?} _callback
     * @return {?}
     */
    init_socket(_callback) {
        /** @type {?} */
        var _this = this;
        if (_this.socketPath && _this.socketport && _this.key) {
            _this.datauxSocket = connect(_this.socketport);
            _this.datauxSocket.on(_this.key, (/**
             * @param {?} data
             * @return {?}
             */
            function (data) {
                _callback(data);
            }));
        }
    }
    /**
     * @param {?} jsonFile
     * @param {?} srcType
     * @param {?} _callback
     * @param {?} _datacallback
     * @return {?}
     */
    getCanvasData(jsonFile, srcType, _callback, _datacallback) {
        /** @type {?} */
        let promise;
        /** @type {?} */
        var apiPath = this.getPaths(srcType);
        if (srcType === 'json') {
            promise = this._JsonService.getCanvasData(apiPath, jsonFile).then((/**
             * @param {?} res
             * @return {?}
             */
            res => {
                if (this.validateCanvasData(res)) {
                    _datacallback(res);
                }
            }));
        }
        else if (srcType === 'xl') {
            promise = this._XldataService.getCanvasData(apiPath, jsonFile, this.project).then((/**
             * @param {?} res
             * @return {?}
             */
            res => {
                if (this.validateCanvasData(res)) {
                    _datacallback(res);
                }
            }));
        }
        else if (srcType === 'socket') {
            /** @type {?} */
            const data = [{ 'name': jsonFile }];
            promise = this._SocketdataService.getCanvasData(apiPath, data).then((/**
             * @param {?} res
             * @return {?}
             */
            res => {
                if (res['status'] === 'Success') {
                    setTimeout((/**
                     * @return {?}
                     */
                    () => {
                        _callback(true);
                    }), 5000);
                }
            }));
        }
    }
    /**
     * @param {?} jsonFile
     * @param {?} srcType
     * @param {?} _callback
     * @param {?} _datacallback
     * @return {?}
     */
    getAssetsData(jsonFile, srcType, _callback, _datacallback) {
        /** @type {?} */
        let promise;
        /** @type {?} */
        var apiPath = this.getPaths(srcType);
        if (srcType === 'json') {
            promise = this._JsonService.getAssetsData(apiPath, jsonFile).then((/**
             * @param {?} res
             * @return {?}
             */
            res => {
                if (this.validateAssetsData(res)) {
                    _datacallback(res);
                }
            }));
        }
        else if (srcType === 'xl') {
            promise = this._XldataService.getAssetsData(apiPath, jsonFile, this.project).then((/**
             * @param {?} res
             * @return {?}
             */
            res => {
                if (this.validateAssetsData(res)) {
                    _datacallback(res);
                }
            }));
        }
        else if (srcType === 'socket') {
            /** @type {?} */
            const data = [{ 'name': jsonFile }];
            promise = this._SocketdataService.getAssetsData(apiPath, data).then((/**
             * @param {?} res
             * @return {?}
             */
            res => {
                if (res['status'] === 'Success') {
                    _callback(true);
                }
            }));
        }
    }
    /**
     * @param {?} jsonFile
     * @param {?} srcType
     * @param {?} _callback
     * @param {?} onGentrateAnimation
     * @param {?} _datacallback
     * @return {?}
     */
    getObjectData(jsonFile, srcType, _callback, onGentrateAnimation, _datacallback) {
        /** @type {?} */
        let promise;
        /** @type {?} */
        var apiPath = this.getPaths(srcType);
        if (srcType === 'json') {
            promise = this._JsonService.getObjectData(apiPath, jsonFile).then((/**
             * @param {?} res
             * @return {?}
             */
            res => {
                if (this.validateObjectData(res)) {
                    _datacallback(res);
                }
            }));
        }
        else if (srcType === 'xl') {
            promise = this._XldataService.getObjectData(apiPath, jsonFile, this.project).then((/**
             * @param {?} res
             * @return {?}
             */
            res => {
                if (this.validateObjectData(res)) {
                    _datacallback(res);
                }
            }));
        }
        else if (srcType === 'socket') {
            /** @type {?} */
            const data = [{ 'name': jsonFile }];
            promise = this._SocketdataService.getObjectData(apiPath, data).then((/**
             * @param {?} res
             * @return {?}
             */
            res => {
                if (res['status'] === 'Success') {
                    setTimeout((/**
                     * @return {?}
                     */
                    () => {
                        _callback(true);
                    }), 5000);
                }
            }));
        }
    }
    /**
     * @param {?} jsonFile
     * @param {?} srcType
     * @param {?} _callback
     * @param {?} _datacallback
     * @return {?}
     */
    getObjectProperties(jsonFile, srcType, _callback, _datacallback) {
        /** @type {?} */
        let promise;
        /** @type {?} */
        var apiPath = this.getPaths(srcType);
        if (srcType === 'json') {
            promise = this._JsonService.getObjectProperties(apiPath, jsonFile).then((/**
             * @param {?} res
             * @return {?}
             */
            res => {
                if (this.validateObjectProperties(res)) {
                    _datacallback(res);
                }
            }));
        }
        else if (srcType === 'xl') {
            promise = this._XldataService.getObjectProperties(apiPath, jsonFile, this.project).then((/**
             * @param {?} res
             * @return {?}
             */
            res => {
                if (this.validateObjectProperties(res)) {
                    _datacallback(res);
                }
            }));
        }
        else if (srcType === 'socket') {
            /** @type {?} */
            const data = [{ 'name': jsonFile }];
            promise = this._SocketdataService.getObjectProperties(apiPath, data).then((/**
             * @param {?} res
             * @return {?}
             */
            res => {
                if (res['status'] === 'Success') {
                    setTimeout((/**
                     * @return {?}
                     */
                    () => {
                        _callback(true);
                    }), 5000);
                }
            }));
        }
    }
    /**
     * @param {?} jsonFile
     * @param {?} srcType
     * @param {?} _callback
     * @param {?} _datacallback
     * @return {?}
     */
    getAnimationData(jsonFile, srcType, _callback, _datacallback) {
        /** @type {?} */
        let promise;
        /** @type {?} */
        var apiPath = this.getPaths(srcType);
        if (srcType === 'json') {
            promise = this._JsonService.getAnimationData(apiPath, jsonFile).then((/**
             * @param {?} res
             * @return {?}
             */
            res => {
                if (this.validateAnimationData(res)) {
                    _datacallback(res);
                }
            }));
        }
        else if (srcType === 'xl') {
            promise = this._XldataService.getAnimationData(apiPath, jsonFile, this.project).then((/**
             * @param {?} res
             * @return {?}
             */
            res => {
                if (this.validateAnimationData(res)) {
                    _datacallback(res);
                }
            }));
        }
        else if (srcType === 'socket') {
            /** @type {?} */
            const data = [{ 'name': jsonFile }];
            promise = this._SocketdataService.getAnimationData(apiPath, data).then((/**
             * @param {?} res
             * @return {?}
             */
            res => {
                if (res['status'] === 'Success') {
                    setTimeout((/**
                     * @return {?}
                     */
                    () => {
                        _callback(true);
                    }), 5000);
                }
            }));
        }
    }
    /**
     * @param {?} jsonFile
     * @param {?} srcType
     * @param {?} _callback
     * @param {?} _datacallback
     * @return {?}
     */
    getData(jsonFile, srcType, _callback, _datacallback) {
        if (srcType === 'json') {
            this.getJsonData(jsonFile, _datacallback);
        }
        else if (srcType === 'xl') {
            this.getXlData(jsonFile, _datacallback);
        }
        else if (srcType === 'socket') {
            /** @type {?} */
            const data = [{ 'name': jsonFile }];
            this.getSocketData(data, _callback);
        }
    }
    /**
     * @param {?} jsonFile
     * @param {?} _datacallback
     * @return {?}
     */
    getJsonData(jsonFile, _datacallback) {
        /** @type {?} */
        let promise;
        promise = this._JsonService.getData(this.JsonPath, jsonFile).then((/**
         * @param {?} res
         * @return {?}
         */
        res => {
            if (this.validateData(res)) {
                _datacallback(res);
            }
        }));
    }
    /**
     * @param {?} jsonFile
     * @param {?} _datacallback
     * @return {?}
     */
    getXlData(jsonFile, _datacallback) {
        /** @type {?} */
        let promise;
        promise = this._XldataService.getData(this.xlPath, jsonFile, this.project).then((/**
         * @param {?} res
         * @return {?}
         */
        res => {
            if (this.validateAnimationData(res)) {
                _datacallback(res);
            }
        }));
    }
    /**
     * @param {?} data
     * @param {?} _callback
     * @return {?}
     */
    getSocketData(data, _callback) {
        /** @type {?} */
        let promise;
        promise = this._SocketdataService.updateStatus(this.socketPath, data).then((/**
         * @param {?} res
         * @return {?}
         */
        res => {
            if (res['status'] === 'Success') {
                setTimeout((/**
                 * @return {?}
                 */
                () => {
                    _callback(true);
                }), 5000);
            }
        }));
    }
}
DataService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
DataService.ctorParameters = () => [
    { type: JsonService },
    { type: XldataService },
    { type: SocketdataService }
];
/** @nocollapse */ DataService.ngInjectableDef = ɵɵdefineInjectable({ factory: function DataService_Factory() { return new DataService(ɵɵinject(JsonService), ɵɵinject(XldataService), ɵɵinject(SocketdataService)); }, token: DataService, providedIn: "root" });
if (false) {
    /** @type {?} */
    DataService.prototype.setting;
    /** @type {?} */
    DataService.prototype.keyDown;
    /** @type {?} */
    DataService.prototype.camera;
    /** @type {?} */
    DataService.prototype.light;
    /** @type {?} */
    DataService.prototype.object;
    /** @type {?} */
    DataService.prototype.JsonPath;
    /** @type {?} */
    DataService.prototype.xlPath;
    /** @type {?} */
    DataService.prototype.socketPath;
    /** @type {?} */
    DataService.prototype.socketport;
    /** @type {?} */
    DataService.prototype.key;
    /** @type {?} */
    DataService.prototype.project;
    /** @type {?} */
    DataService.prototype.datauxSocket;
    /**
     * @type {?}
     * @private
     */
    DataService.prototype._JsonService;
    /**
     * @type {?}
     * @private
     */
    DataService.prototype._XldataService;
    /**
     * @type {?}
     * @private
     */
    DataService.prototype._SocketdataService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/datauxview.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
let modelDefn;
/** @type {?} */
const modelMap = {};
class DatauxviewComponent {
    /**
     * @param {?} _DataService
     */
    constructor(_DataService) {
        this._DataService = _DataService;
        this._allElements = {};
        this.venue_orientation = 0.001;
        this.yaw_2d = 0.001;
        this.yaw_3d = 0.001;
        this.pitch_3d = 45;
        /**
         * variable to store the datascape instance
         * it controls the loading/creation/interactions of 3D objects
         */
        this._datascape = null;
        this.isDragmove = false;
        this.isMouseDown = false;
        this.cameraview = {};
        /**
         * \@GetEulers_deg - get mesh degree
         */
        // tslint:disable-next-line: member-ordering
        this.PI = 3.1415926;
        this.mode2D = false;
        this.last_pitch = null;
        this.lastSelectedShape = null;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onMouseup(event) {
        if (this.lastEvent.clientX === event.clientX && this.lastEvent.clientY === event.clientY) {
            this.isDragmove = false;
        }
        else {
            this.isDragmove = true;
        }
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onMouseMove(event) {
        this.lastEvent = event;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    handleKeyboardEvent(event) {
        /** @type {?} */
        const key = event.key.toString().toLowerCase();
        if (document.activeElement.classList.contains('rendererCanvas')) {
            if (key === 'l' || key === 'r' || key === 'f' || key === 'b') {
                event.preventDefault();
            }
        }
    }
    /**
     * @param {?} event
     * @return {?}
     */
    handleMouseDownEvent(event) {
        this.isMouseDown = true;
    }
    /**
     * @param {?} filename
     * @param {?} format
     * @param {?} _callback
     * @return {?}
     */
    loadCanvas(filename, format, _callback) {
        System.import('../../dfx_lib/earcut.js').then((/**
         * @param {?} earcutlib
         * @return {?}
         */
        earcutlib => {
            if (!window.earcut) {
                window.earcut = earcutlib.default;
            }
        }));
        System.import('../../dfx_lib/cannon.js').then((/**
         * @param {?} cannon
         * @return {?}
         */
        cannon => {
            if (!window.CANNON) {
                window.CANNON = cannon.default;
            }
        }));
        System.import('../../dfx_lib/dataux.js').then((/**
         * @param {?} datauxlib
         * @return {?}
         */
        datauxlib => {
            this.datauxlib = datauxlib;
            this._DataService.getCanvasData(filename, format, _callback, (/**
             * @param {?} _data
             * @return {?}
             */
            (_data) => {
                /** @type {?} */
                let data = Object.assign(_data, this.project_settings);
                this._startDataUX(data, _callback);
                this._DataService.init_socket((/**
                 * @param {?} data
                 * @return {?}
                 */
                (data) => {
                    this.socketData(data);
                }));
            }));
        }));
    }
    /**
     * @param {?} config
     * @return {?}
     */
    setProjectSettins(config) {
        this.project_settings = config;
        this.setJSONPath(this.project_settings.JsonPath);
    }
    /**
     * @param {?} path
     * @return {?}
     */
    setJSONPath(path) {
        this._DataService.JsonPath = path;
    }
    /**
     * @param {?} filename
     * @param {?} format
     * @param {?} _callback
     * @return {?}
     */
    loadAssets(filename, format, _callback) {
        this._DataService.getAssetsData(filename, format, _callback, (/**
         * @param {?} jsonObj
         * @return {?}
         */
        (jsonObj) => {
            this._createModels(jsonObj['shapes'], _callback);
        }));
    }
    /**
     * @param {?} filename
     * @param {?} format
     * @param {?} _callback
     * @return {?}
     */
    loadData(filename, format, _callback) {
        this._DataService.getData(filename, format, (/**
         * @return {?}
         */
        () => { }), (/**
         * @param {?} jsonObj
         * @return {?}
         */
        (jsonObj) => {
            _callback(jsonObj);
        }));
    }
    /**
     * @param {?} filename
     * @param {?} format
     * @param {?} _callback
     * @param {?} onGentrateAnimation
     * @return {?}
     */
    renderAssets(filename, format, _callback, onGentrateAnimation) {
        this._DataService.getObjectData(filename, format, _callback, onGentrateAnimation, (/**
         * @param {?} jsonObj
         * @return {?}
         */
        (jsonObj) => {
            /** @type {?} */
            let modelDefn = jsonObj['objects'];
            this.addElements(modelDefn, _callback, onGentrateAnimation);
        }));
    }
    /**
     * @param {?} filename
     * @param {?} format
     * @param {?} _callback
     * @return {?}
     */
    assignAssetsProperties(filename, format, _callback) {
        this.modifyElements(filename, format, _callback);
    }
    /**
     * @param {?} filename
     * @param {?} format
     * @param {?} _callback
     * @return {?}
     */
    AnimateAssets(filename, format, _callback) {
        this._DataService.getAnimationData(filename, format, _callback, (/**
         * @param {?} jsonObj
         * @return {?}
         */
        (jsonObj) => {
            Object.entries(jsonObj['objects']).forEach((/**
             * @param {?} __0
             * @return {?}
             */
            ([key, value]) => {
            }));
        }));
    }
    /**
     * @param {?} _dfx_settings
     * @param {?} _callback
     * @return {?}
     */
    addSettings(_dfx_settings, _callback) {
        /** @type {?} */
        let json_options = { canvas: this.rendererCanvas.nativeElement, settings: _dfx_settings };
        this.datauxlib.Datascape(json_options).then((/**
         * @param {?} instance
         * @return {?}
         */
        (instance) => {
            // Save the datascape pointer for global use
            this._setDatascape(instance);
            instance.start(); // started dataux libarary
            _callback(_dfx_settings, true);
        }), (/**
         * @param {?} err
         * @return {?}
         */
        (err) => {
            alert(err);
        }));
    }
    /**
     * @param {?} licenseinfo
     * @return {?}
     */
    validateLicence(licenseinfo) {
        // let old =localStorage.getItem("dfx::licence::info");
        // if(old){
        //   localStorage.removeItem("dfx::licence::info")
        // }
        /** @type {?} */
        let iObj = JSON.parse(licenseinfo);
        if (iObj.licencetype === 'full') {
            return "Valid";
        }
        /** @type {?} */
        let startDate = new Date(iObj.installed);
        /** @type {?} */
        let currentDate = new Date();
        /** @type {?} */
        let difference_In_Time = currentDate.getTime() - startDate.getTime();
        /** @type {?} */
        let difference_In_Days = Math.floor(difference_In_Time / (1000 * 3600 * 24));
        /** @type {?} */
        let expiresIn = iObj.trialperiod;
        if (difference_In_Days < expiresIn) {
            /** @type {?} */
            let daysLeft = expiresIn - difference_In_Days;
            return 'Trial-daysleft-' + daysLeft;
        }
        else {
            return 'Trial Expired';
        }
    }
    /**
     * @return {?}
     */
    licenceTermsCallback() {
        alert("Show Terms of licence here.");
    }
    /**
     * @param {?} _dfx_settings
     * @param {?} _callback
     * @return {?}
     */
    _startDataUX(_dfx_settings, _callback) {
        _dfx_settings.licenceValidator = (/**
         * @param {?} linfo
         * @return {?}
         */
        (linfo) => { return this.validateLicence(linfo); });
        _dfx_settings.licenceTermsCallback = (/**
         * @return {?}
         */
        () => { return this.licenceTermsCallback(); });
        this.cameraview = _dfx_settings.camera.views;
        /** @type {?} */
        var dynamicshape = false;
        dynamicshape = _dfx_settings.createDynamicShape;
        if (dynamicshape) {
            _callback(_dfx_settings, false);
        }
        else {
            this.addSettings(_dfx_settings, _callback);
        }
    }
    /**
     * @param {?} _data
     * @return {?}
     */
    socketData(_data) {
        console.log('_data : ', _data);
        this.socketdata = _data;
        /** @type {?} */
        const data = JSON.parse(_data);
        /** @type {?} */
        var _this = this;
        if (data.settings) {
            _this._startDataUX(data.settings, (/**
             * @param {?} settingstatus
             * @return {?}
             */
            (settingstatus) => {
                if (settingstatus) {
                    console.log("socket's settings is loaded successfully");
                }
            }));
        }
        if (data.shapes) {
            _this._createModels(data.shapes, (/**
             * @param {?} objectstatus
             * @return {?}
             */
            (objectstatus) => {
                if (objectstatus) {
                    console.log("socket's shapes is loaded successfully");
                }
            }));
        }
        if (data.objects) {
            _this.addElements(data.objects, (/**
             * @param {?} objectstatus
             * @return {?}
             */
            (objectstatus) => {
                if (objectstatus) {
                    console.log("socket's elements is loaded successfully");
                }
            }), null);
        }
    }
    // load all model maps here
    /**
     * @param {?} _modelDefn
     * @param {?} _callback
     * @return {?}
     */
    _createModels(_modelDefn, _callback) {
        /** @type {?} */
        let odatascape = this.getDatascape();
        // console.log('_modelDefn', _modelDefn);
        for (const val of Object.values(_modelDefn)) {
            /** @type {?} */
            const modname = Object.keys(val)[0];
            /** @type {?} */
            let trans = 0;
            /** @type {?} */
            const size = Object.values(val)[0].size;
            /** @type {?} */
            const modelProps = {
                shape: Object.values(val)[0].model,
                id: Object.keys(val)[0],
                initialGeometry: { orientation: { x: 0, y: 0, z: 0 }, position: { x: 0, y: 0, z: 0 }, size },
                profiles: {
                    regular: {
                        material: Object.values(val)[0].material,
                        transition: trans,
                        // in milliseconds
                        visible: true,
                        shadow: true,
                        selectable: true,
                        wireframe: false
                    },
                    invisible: {
                        material: Object.values(val)[0].material,
                        transition: 0,
                        visible: false,
                        shadow: !true,
                        selectable: false
                    },
                    transparent: {
                        material: 'transparent',
                        transition: 500,
                        // in milliseconds
                        visible: true
                    },
                    blue: {
                        material: 'red',
                        transition: trans,
                        // in milliseconds
                        visible: true,
                        shadow: true,
                        selectable: true,
                        wireframe: false
                    },
                    red: {
                        material: 'red_mtl',
                        transition: 500,
                        visible: true,
                        shadow: true,
                        selectable: true,
                        wireframe: false
                    },
                    green: {
                        material: 'green_mtl',
                        transition: 500,
                        visible: true,
                        shadow: true,
                        selectable: true,
                        wireframe: false
                    }
                },
                tag: { label: Object.keys(val)[0] }
            };
            modelProps.profiles['colour_mtl'] = {
                material: 'colour_mtl',
                transition: 500,
                visible: true,
                shadow: true,
                selectable: true,
                wireframe: false
            };
            /** @type {?} */
            const model = odatascape.model(modelProps);
            modelMap[Object.keys(val)[0]] = model;
        }
        _callback(true);
    }
    /**
     * @param {?} dfx
     * @param {?} opt
     * @return {?}
     */
    addModel(dfx, opt) {
        return dfx.model(opt);
    }
    /**
     * @param {?} shape
     * @param {?} id
     * @param {?} profiles
     * @param {?} settings
     * @param {?=} tag
     * @return {?}
     */
    addElement(shape, id, profiles, settings, tag = null) {
        /** @type {?} */
        let dfx = this.getDatascape();
        /** @type {?} */
        let opt = {
            shape,
            id: 'e_' + shape,
            profiles
        };
        if (tag) {
            opt['tag'] = tag;
        }
        /** @type {?} */
        let m = this.addModel(dfx, opt);
        /** @type {?} */
        let el = dfx.add({
            id: id,
            model: m,
            geometry: settings.geometry,
            tag: tag || null
        });
        if (settings.scale) {
            dfx.setElementScale(el, settings.scale);
        }
        this._allElements[id] = el;
    }
    /**
     * @param {?} modelDefn
     * @param {?} _callback
     * @param {?} onGentrateAnimation
     * @return {?}
     */
    addElements(modelDefn, _callback, onGentrateAnimation) {
        Object.entries(modelDefn).forEach((/**
         * @param {?} __0
         * @return {?}
         */
        ([key, value]) => {
            /** @type {?} */
            let model;
            /** @type {?} */
            let id;
            /** @type {?} */
            let size;
            model = value['model'];
            id = value['name'];
            size = value['place']['size'];
            /** @type {?} */
            const elemGeometry = { 'geometry': { 'orientation': { x: 0, y: 0, z: 0 }, 'position': { x: 0, y: 0, z: 0 }, 'size': size } };
            elemGeometry['geometry']['position'] = value['place']['pos'];
            elemGeometry['geometry']['orientation'] = value['place']['rot'];
            /** @type {?} */
            const newElem = this.getDatascape().add({
                id: id,
                model: modelMap[model],
                geometry: elemGeometry['geometry']
            });
            this.getDatascape().attach(newElem, {
                actions: {
                    pickDown: [(/**
                         * @param {?} evt
                         * @param {?} elem
                         * @return {?}
                         */
                        (evt, elem) => {
                            if (evt.button === 0) {
                                onGentrateAnimation(this.getDatascape().props(elem)['id'], 'pickDown');
                            }
                        })],
                    pickUp: [(/**
                         * @param {?} evt
                         * @param {?} elem
                         * @return {?}
                         */
                        (evt, elem) => {
                            if (evt.button === 0) {
                                onGentrateAnimation(this.getDatascape().props(elem)['id'], 'pickUp');
                            }
                        })],
                    pickLeft: [(/**
                         * @param {?} evt
                         * @param {?} elem
                         * @return {?}
                         */
                        (evt, elem) => {
                            if (evt.button === 0) {
                                onGentrateAnimation(this.getDatascape().props(elem)['id'], 'pickLeft');
                            }
                        })],
                    pickDouble: [(/**
                         * @param {?} evt
                         * @param {?} elem
                         * @return {?}
                         */
                        (evt, elem) => {
                            if (evt.button === 0) {
                                onGentrateAnimation(this.getDatascape().props(elem)['id'], 'pickDouble');
                            }
                        })]
                }
            });
            this._allElements[id] = newElem;
            /** @type {?} */
            const mesh = this.getDatascape().getElementMesh(this._allElements[id]);
            if (value['type'] === 'billboard') {
                mesh.billboardMode = 7;
            }
            if (value['parent']) {
                /** @type {?} */
                const parent = this._allElements[value['parent']];
                this.getDatascape().setAsParent(parent, [this._allElements[id]]);
            }
        }));
        _callback(modelDefn);
    }
    /**
     * @return {?}
     */
    getElementsid() {
        /** @type {?} */
        var keys = [];
        Object.entries(this._allElements).forEach((/**
         * @param {?} __0
         * @return {?}
         */
        ([key, value]) => {
            keys.push(key);
        }));
        return keys;
    }
    /**
     * @param {?} elementID
     * @return {?}
     */
    getElementId(elementID) {
        return this._allElements[elementID];
    }
    /**
     * @return {?}
     */
    allObjects() {
        return this._allElements;
    }
    /**
     * @param {?} mesh
     * @return {?}
     */
    GetEulers_deg(mesh) {
        /** @type {?} */
        let eulers_deg;
        if (mesh.rotationQuaternion) {
            eulers_deg = mesh.rotationQuaternion.toEulerAngles().scale(180 / this.PI);
        }
        else {
            eulers_deg = mesh.rotation.scale(180 / this.PI);
        }
        return eulers_deg;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    modifyElement(value) {
        /** @type {?} */
        const id = value['name'];
        /** @type {?} */
        const elemGeometry = { 'geometry': { 'orientation': { x: 0, y: 0, z: 0 }, 'position': { x: 0, y: 0, z: 0 } } };
        elemGeometry['geometry']['position'] = value['place']['pos'];
        elemGeometry['geometry']['orientation'] = value['place']['rot'];
        elemGeometry['geometry']['size'] = value['place']['size'];
        this.getDatascape().modify(this._allElements[id], { geometry: elemGeometry['geometry'], profile: value['profile'] });
    }
    /**
     * @param {?} filename
     * @param {?} format
     * @param {?} _callback
     * @return {?}
     */
    modifyElements(filename, format, _callback) {
        this._DataService.getObjectProperties(filename, format, _callback, (/**
         * @param {?} jsonObj
         * @return {?}
         */
        (jsonObj) => {
            Object.entries(jsonObj['objects']).forEach((/**
             * @param {?} __0
             * @return {?}
             */
            ([key, value]) => {
                this.modifyElement(value);
            }));
        }));
    }
    // method to encapsulate datascape object
    /**
     * @param {?} handle
     * @return {?}
     */
    _setDatascape(handle) {
        this._datascape = handle;
    }
    /**
     * @return {?}
     */
    getDatascape() {
        return this._datascape;
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this.position();
    }
    /**
     * @return {?}
     */
    position() {
        console.log('fix position');
        /** @type {?} */
        const ht = window.innerHeight;
        // wht = 0;
        this.offHeight = ht + 'px';
        this.winHeight = window.innerHeight + 'px';
        if (this.show_full_screen === true) {
            this.winWidth = window.innerWidth + 'px';
        }
        else {
            this.winWidth = window.innerWidth + 'px';
        }
        this.triggerWindowResize();
    }
    /**
     * @return {?}
     */
    triggerWindowResize() {
        window.dispatchEvent(new Event('resize'));
    }
    /**
     * @param {?} data
     * @return {?}
     */
    addDynamicShape(data) {
        this.addGLTFModel(this.getDatascape(), data);
    }
    /**
     * @param {?} dfx
     * @param {?} gobj
     * @return {?}
     */
    addGLTFModel(dfx, gobj) {
        //let shapes=gobj
        dfx.addDynamicShapes(gobj).then((/**
         * @param {?} e
         * @return {?}
         */
        (e) => {
            console.log(e);
            setTimeout((/**
             * @return {?}
             */
            () => {
                /** @type {?} */
                let opt = {
                    shape: '__root__',
                    id: 'e_node1',
                    profiles: {
                        regular: {
                            material: 'custom-included' /** material already defined in gltf */
                        }
                    }
                };
                /** @type {?} */
                let mymodel = dfx.model(opt);
                /** @type {?} */
                let el;
                setTimeout((/**
                 * @return {?}
                 */
                () => {
                    el = dfx.add({
                        id: 'e_node1_1',
                        model: mymodel,
                        geometry: { position: { x: 0, y: 0.0, z: 0 }, size: 1 }
                    });
                    /** @type {?} */
                    let mesh = dfx.getElementMesh(el);
                    mesh.scaling.z = -1;
                }));
            }), 0);
        }));
    }
    /**
     * @param {?} key
     * @return {?}
     */
    triggerKeyEvent(key) {
        if (key === 'escape') {
            // this.clearAllSelection(true);
            // this.clearSearch(null);
            return;
        }
        /** @type {?} */
        const node = this.rendererCanvas.nativeElement;
        /** @type {?} */
        const e = new Event('keydown');
        if (key.toLowerCase() === 'l' || key.toLowerCase() === 'r' || key.toLowerCase() === 'f' || key.toLowerCase() === 'b') {
            if (this.mode2D) {
                key = key.toUpperCase();
            }
            else {
                key = key.toLowerCase();
                // this.triggerCameraNaviagtion(key);
                return;
            }
        }
        e.key = key || 't'; // just enter the char you want to send
        e.keyCode = key === 'escape' ? 27 : e.key.charCodeAt(0);
        e.which = e.keyCode;
        e.altKey = false;
        e.ctrlKey = false;
        e.shiftKey = false;
        e.metaKey = false;
        node.focus();
        node.dispatchEvent(e);
    }
    /**
     * @param {?} key
     * @return {?}
     */
    startZoom(key) {
        this.triggerKeyEvent(key);
        if (this.zoomIntervalId) {
            clearInterval(this.zoomIntervalId);
        }
        this.zoomIntervalId = setInterval((/**
         * @return {?}
         */
        () => { this.triggerKeyEvent(key); }), 0);
    }
    /**
     * continuous zoom - stop
     * on button release
     * @param {?=} key
     * @return {?}
     */
    stopZoom(key = null) {
        clearInterval(this.zoomIntervalId);
    }
    /**
     * @param {?} view
     * @return {?}
     */
    Camera(view) {
        if (this.cameraview) {
            /** @type {?} */
            var data = this.cameraview[view];
            this.getDatascape().moveCamera(data);
        }
    }
    /**
     * @return {?}
     */
    trigger3dmode() {
        this.getDatascape().switchPerspective({ pitch: this.last_pitch || this.pitch_3d, yaw: this.yaw_3d || this.venue_orientation });
    }
    /**
     * switch to 2D mode
     * @return {?}
     */
    trigger2dmode() {
        this.getDatascape().switchOrtho({ yaw: this.yaw_2d || this.venue_orientation });
    }
    /**
     * @param {?} mode
     * @return {?}
     */
    CameraMode(mode) {
        if (mode == '2D') {
            /** @type {?} */
            let cam = this.getDatascape().getCamera();
            this.last_pitch = cam.pitch_deg.value;
            this.trigger2dmode();
        }
        else if (mode == '3D') {
            this.last_pitch = null;
            this.trigger3dmode();
        }
    }
    /**
     * @param {?} key
     * @return {?}
     */
    getObjectProperties(key) {
        /** @type {?} */
        let elem = this.getDatascape().props(this._allElements[key]);
        this.showShapeProperties(key);
        return elem;
    }
    /**
     * @param {?} shape
     * @return {?}
     */
    showShapeProperties(shape) {
        /** @type {?} */
        const elem = this.getDatascape().props(this._allElements[shape]);
        if (elem) {
            /** @type {?} */
            let geopos = { 'position': { 'x': elem.geometry.position.x, 'y': elem.geometry.position.y, 'z': elem.geometry.position.z } };
            /** @type {?} */
            var mesh = this.getDatascape().getElementMesh(this._allElements[shape]);
            /** @type {?} */
            var target_pos = mesh.getAbsolutePosition();
            /** @type {?} */
            var data = { "target": { "x": target_pos.x, "y": target_pos.y, "z": target_pos.z } };
            this.getDatascape().moveCamera(data);
            if (this.lastSelectedShape != null) {
                if (this.lastSelectedShape == shape) {
                    this.getDatascape().modify(this._allElements[this.lastSelectedShape], { profile: 'regular' });
                    this.lastSelectedShape = null;
                }
                else {
                    if (this.lastSelectedShape != shape) {
                        this.getDatascape().modify(this._allElements[this.lastSelectedShape], { profile: 'regular' });
                        this.getDatascape().modify(this._allElements[shape], { geometry: geopos, profile: 'blue' });
                    }
                    this.lastSelectedShape = shape;
                }
            }
            else {
                this.getDatascape().modify(this._allElements[shape], { geometry: geopos, profile: 'blue' });
                this.lastSelectedShape = shape;
            }
        }
    }
    /**
     * @param {?} _keyCode
     * @return {?}
     */
    triggerKey(_keyCode) {
        console.log('key triggered' + _keyCode);
        /** @type {?} */
        let event = (/** @type {?} */ (document.createEvent('CustomEvent')));
        // event.which = 'a';
        // event.key = 'a';
        event.shiftKey = true;
        // event.bubbles = true;
        // event.cancelable = true;
        event.keyCode = _keyCode;
        event.initEvent('keydown', true, true);
        this.rendererCanvas.nativeElement.focus();
        this.rendererCanvas.nativeElement.dispatchEvent(event);
    }
    /**
     * @param {?} elem
     * @return {?}
     */
    getElementMesh(elem) {
        return this.getDatascape().getElementMesh(elem);
    }
    /**
     * @param {?} data
     * @return {?}
     */
    socketAnimation(data) {
        this._DataService.getSocketData(data, (/**
         * @param {?} status
         * @return {?}
         */
        (status) => {
            console.log('status : success');
        }));
    }
    /**
     * @param {?} data
     * @param {?} callback
     * @return {?}
     */
    attachDynamicObject(data, callback) {
        /** @type {?} */
        var result;
        this.addSettings(data, (/**
         * @param {?} da
         * @param {?} status
         * @return {?}
         */
        (da, status) => {
            callback(status);
        }));
    }
}
DatauxviewComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-datauxview',
                template: "<div class=\"engine-wrapper\">\n  <canvas #rendererCanvas id=\"renderCanvas\"></canvas>\n</div>\n",
                styles: [""]
            }] }
];
/** @nocollapse */
DatauxviewComponent.ctorParameters = () => [
    { type: DataService }
];
DatauxviewComponent.propDecorators = {
    rendererCanvas: [{ type: ViewChild, args: ['rendererCanvas', { static: true },] }],
    onMouseup: [{ type: HostListener, args: ['click', ['$event'],] }],
    onMouseMove: [{ type: HostListener, args: ['mousemove', ['$event'],] }],
    handleKeyboardEvent: [{ type: HostListener, args: ['document:keydown', ['$event'],] }],
    handleMouseDownEvent: [{ type: HostListener, args: ['document:mousedown', ['$event'],] }]
};
if (false) {
    /** @type {?} */
    DatauxviewComponent.prototype.offHeight;
    /** @type {?} */
    DatauxviewComponent.prototype.winWidth;
    /** @type {?} */
    DatauxviewComponent.prototype.winHeight;
    /** @type {?} */
    DatauxviewComponent.prototype.show_full_screen;
    /**
     * @type {?}
     * @private
     */
    DatauxviewComponent.prototype._allElements;
    /** @type {?} */
    DatauxviewComponent.prototype.JsonPath;
    /** @type {?} */
    DatauxviewComponent.prototype.xlPath;
    /** @type {?} */
    DatauxviewComponent.prototype.socketPath;
    /** @type {?} */
    DatauxviewComponent.prototype.socketport;
    /** @type {?} */
    DatauxviewComponent.prototype.datauxSocket;
    /** @type {?} */
    DatauxviewComponent.prototype.xlapipath;
    /** @type {?} */
    DatauxviewComponent.prototype.project_settings;
    /** @type {?} */
    DatauxviewComponent.prototype.venue_orientation;
    /** @type {?} */
    DatauxviewComponent.prototype.yaw_2d;
    /** @type {?} */
    DatauxviewComponent.prototype.yaw_3d;
    /** @type {?} */
    DatauxviewComponent.prototype.pitch_3d;
    /** @type {?} */
    DatauxviewComponent.prototype.rendererCanvas;
    /**
     * variable to store dataux library
     * @type {?}
     */
    DatauxviewComponent.prototype.datauxlib;
    /** @type {?} */
    DatauxviewComponent.prototype.socketdata;
    /**
     * variable to store the datascape instance
     * it controls the loading/creation/interactions of 3D objects
     * @type {?}
     */
    DatauxviewComponent.prototype._datascape;
    /** @type {?} */
    DatauxviewComponent.prototype.lastEvent;
    /** @type {?} */
    DatauxviewComponent.prototype.isDragmove;
    /** @type {?} */
    DatauxviewComponent.prototype.isMouseDown;
    /** @type {?} */
    DatauxviewComponent.prototype.cameraview;
    /**
     * \@GetEulers_deg - get mesh degree
     * @type {?}
     */
    DatauxviewComponent.prototype.PI;
    /** @type {?} */
    DatauxviewComponent.prototype.mode2D;
    /**
     * continuous zoom - start
     * on button press
     * @type {?}
     */
    DatauxviewComponent.prototype.zoomIntervalId;
    /** @type {?} */
    DatauxviewComponent.prototype.last_pitch;
    /** @type {?} */
    DatauxviewComponent.prototype.lastSelectedShape;
    /**
     * @type {?}
     * @private
     */
    DatauxviewComponent.prototype._DataService;
}
;

/**
 * @fileoverview added by tsickle
 * Generated from: lib/datauxview.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DatauxviewModule {
}
DatauxviewModule.decorators = [
    { type: NgModule, args: [{
                declarations: [DatauxviewComponent],
                imports: [],
                providers: [JsonService],
                exports: [DatauxviewComponent]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: datauxview.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { DatauxviewComponent, DatauxviewModule, JsonService, DataService as ɵa, XldataService as ɵb, SocketdataService as ɵc };
//# sourceMappingURL=datauxview.js.map
